/**
 * Workshop events calendar — filtered list with date range + type pills.
 * Fetch: section data-wec-fetch-* lat/lng/radius + start_date/end_date query params.
 */
(function () {
  'use strict';

  var TYPE_ORDER = ['mosaic', 'ceramic', 'resin'];
  var MONTH_NAMES = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];

  var VENUE_PALETTE = [
    { bg: '#e8f4f8', border: '#9ec5d4', text: '#1a4a5c' },
    { bg: '#f5ebe0', border: '#d4b896', text: '#5c3d1a' },
    { bg: '#ede9fe', border: '#b8a9f0', text: '#4c1d95' },
    { bg: '#ecfdf5', border: '#9fd9bf', text: '#14532d' },
    { bg: '#fce7f3', border: '#f0a8d0', text: '#831843' },
    { bg: '#fff7ed', border: '#f5c48a', text: '#7c2d12' },
    { bg: '#f0f9ff', border: '#9bd5f5', text: '#0c4a6e' },
    { bg: '#f7fee7', border: '#c8e6a0', text: '#365314' }
  ];

  function pad2(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function escHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function escAttr(s) {
    return escHtml(s).replace(/"/g, '&quot;');
  }

  function parseConfig(root) {
    var el = root.querySelector('[data-wec-config]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (_) {
      return null;
    }
  }

  function getEventStart(ev) {
    return (ev && (ev.start_time || ev.starts_at || ev.date || ev.startsAt)) || '';
  }

  function eventDisplayTime(ev) {
    var tl = String((ev && (ev.time_label || ev.timeLabel)) || '').trim();
    if (/\d{1,2}:\d{2}/.test(tl)) return formatWallClockTime(tl) || tl;
    return formatWallClockTime(getEventStart(ev)) || tl;
  }

  function getEventDateKey(ev) {
    if (!ev) return '';
    var dateKey = (ev.date_key || '').toString().trim();
    if (dateKey) return dateKey.slice(0, 10);
    var startRaw = getEventStart(ev);
    if (!startRaw) return '';
    var m = String(startRaw).match(/^(\d{4}-\d{2}-\d{2})/);
    return m ? m[1] : '';
  }

  function parseDateKey(dateKey) {
    if (!dateKey) return null;
    var parts = String(dateKey).split('-');
    if (parts.length !== 3) return null;
    var y = Number(parts[0]);
    var m = Number(parts[1]) - 1;
    var d = Number(parts[2]);
    if (!Number.isFinite(y) || !Number.isFinite(m) || !Number.isFinite(d)) return null;
    return new Date(y, m, d);
  }

  function toDateKey(dateObj) {
    if (!(dateObj instanceof Date) || Number.isNaN(dateObj.getTime())) return '';
    return dateObj.getFullYear() + '-' + pad2(dateObj.getMonth() + 1) + '-' + pad2(dateObj.getDate());
  }

  function formatWallClockTime(raw) {
    if (!raw) return '';
    var s = String(raw).trim();
    if (/\d{1,2}:\d{2}\s*[AP]M/i.test(s) && s.indexOf('T') === -1 && !/^\d{4}-\d{2}-\d{2}/.test(s)) {
      return s.replace(/\s+/g, ' ');
    }
    var t = s.indexOf('T');
    if (t !== -1) {
      var rest = s.slice(t + 1);
      var m = rest.match(/^(\d{1,2}):(\d{2})/);
      if (m) {
        var hh = parseInt(m[1], 10);
        var mm = parseInt(m[2], 10);
        var h12 = hh % 12 || 12;
        var ap = hh < 12 ? 'AM' : 'PM';
        return h12 + ':' + pad2(mm) + ' ' + ap;
      }
    }
    var m2 = s.match(/(\d{4}-\d{2}-\d{2})\s+(\d{1,2}):(\d{2})/);
    if (m2) {
      var hh2 = parseInt(m2[2], 10);
      var mm2 = parseInt(m2[3], 10);
      var h122 = hh2 % 12 || 12;
      var ap2 = hh2 < 12 ? 'AM' : 'PM';
      return h122 + ':' + pad2(mm2) + ' ' + ap2;
    }
    return '';
  }

  function formatDisplayDate(dateKey) {
    var d = parseDateKey(dateKey);
    if (!d) return '';
    return pad2(d.getMonth() + 1) + '/' + pad2(d.getDate()) + '/' + d.getFullYear();
  }

  function isValidDateKey(dateKey) {
    var d = parseDateKey(dateKey);
    if (!d) return false;
    var y = d.getFullYear();
    return y >= 2000 && y <= 2100;
  }

  function parseFlexibleDate(raw) {
    var s = (raw == null ? '' : String(raw)).trim();
    if (!s) return '';
    var iso = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
    if (iso) {
      var isoKey = iso[1] + '-' + pad2(Number(iso[2])) + '-' + pad2(Number(iso[3]));
      return isValidDateKey(isoKey) ? isoKey : '';
    }
    var slash = s.match(/^(\d{1,2})[\/.\-](\d{1,2})[\/.\-](\d{4})$/);
    if (slash) {
      var slashKey =
        slash[3] + '-' + pad2(Number(slash[1])) + '-' + pad2(Number(slash[2]));
      return isValidDateKey(slashKey) ? slashKey : '';
    }
    var d = parseDateKey(s);
    if (d) {
      var key = toDateKey(d);
      return isValidDateKey(key) ? key : '';
    }
    return '';
  }

  function venueColorForKey(key) {
    var h = 0;
    var s = String(key || '');
    for (var i = 0; i < s.length; i++) {
      h = ((h << 5) - h + s.charCodeAt(i)) | 0;
    }
    return VENUE_PALETTE[Math.abs(h) % VENUE_PALETTE.length];
  }

  function getVenueClusterKey(venue) {
    var v = venue || {};
    return [
      (v.handle || v.venue_handle || '').toString().trim(),
      (v.venue_name || '').toString().trim(),
      (v.venue_address || '').toString().trim()
    ].join('|');
  }

  function clusterByVenue(eventGroups) {
    var map = new Map();
    eventGroups.forEach(function (item) {
      var key = getVenueClusterKey(item.venue);
      if (!map.has(key)) {
        map.set(key, { key: key, venue: item.venue || {}, cards: [] });
      }
      map.get(key).cards.push(item);
    });
    var clusters = Array.from(map.values());
    clusters.forEach(function (cluster) {
      cluster.cards.sort(function (a, b) {
        return String(a.dateKey || '').localeCompare(String(b.dateKey || ''));
      });
    });
    clusters.sort(function (a, b) {
      var da = (a.cards[0] && a.cards[0].dateKey) || '';
      var db = (b.cards[0] && b.cards[0].dateKey) || '';
      return da.localeCompare(db);
    });
    return clusters;
  }

  function formatMonth(d) {
    if (!d) return '';
    return d.toLocaleString('en', { month: 'short' }).toUpperCase();
  }

  function formatDay(d) {
    return d ? d.getDate() : '--';
  }

  function formatMonthYear(dateObj) {
    if (!(dateObj instanceof Date) || Number.isNaN(dateObj.getTime())) return '';
    return dateObj.toLocaleString('en-US', { month: 'long', year: 'numeric' });
  }

  function ensureCalendarCursor(cursor, fallbackDate) {
    if (cursor instanceof Date && !Number.isNaN(cursor.getTime())) {
      return new Date(cursor.getFullYear(), cursor.getMonth(), 1);
    }
    var seed =
      fallbackDate instanceof Date && !Number.isNaN(fallbackDate.getTime())
        ? fallbackDate
        : new Date();
    return new Date(seed.getFullYear(), seed.getMonth(), 1);
  }

  function getCalendarYearBounds() {
    var current = new Date().getFullYear();
    return { min: current - 1, max: current + 3 };
  }

  function readThemeVenues() {
    var el = document.getElementById('venue-explorer-data');
    if (!el || !el.textContent) return [];
    try {
      var rows = JSON.parse(el.textContent);
      return Array.isArray(rows) ? rows : [];
    } catch (e) {
      return [];
    }
  }

  function readThemeEventRows() {
    var nodes = document.querySelectorAll('#venue-explorer-events, [data-wec-events], [data-wef-events]');
    var i;
    for (i = 0; i < nodes.length; i++) {
      try {
        var rows = JSON.parse(nodes[i].textContent || '[]');
        if (Array.isArray(rows) && rows.length) return rows;
      } catch (e) {}
    }
    return [];
  }

  function gidForType(type, productTypes) {
    var keys = Object.keys(productTypes || {});
    for (var i = 0; i < keys.length; i++) {
      if (productTypes[keys[i]] === type) return keys[i];
    }
    return '';
  }

  function typeFromEvent(ev, productTypes) {
    var hub = ev && ev.hub_product;
    if (hub && productTypes && productTypes[hub]) return productTypes[hub];
    var wp = ev && (ev.workshop_product || ev.product_gid);
    if (wp && productTypes && productTypes[wp]) return productTypes[wp];
    var blob = (
      String((ev && ev.product_handle) || '') +
      ' ' +
      String((ev && (ev.product_title || ev.event_name || ev.product_name)) || '')
    ).toLowerCase();
    if (blob.indexOf('mosaic') !== -1) return 'mosaic';
    if (blob.indexOf('ceramic') !== -1) return 'ceramic';
    if (blob.indexOf('resin') !== -1) return 'resin';
    return '';
  }

  function getWorkshopTypeKey(item, productTypes) {
    var fromEvent = typeFromEvent(item && item.event, productTypes);
    if (fromEvent) return fromEvent;
    var gid = item && item.product_gid;
    if (gid && productTypes && productTypes[gid]) return productTypes[gid];
    var name = (item && item.product_name ? String(item.product_name) : '').toLowerCase();
    if (name.indexOf('mosaic') !== -1) return 'mosaic';
    if (name.indexOf('ceramic') !== -1) return 'ceramic';
    if (name.indexOf('resin') !== -1) return 'resin';
    return '';
  }

  function matchesTypeFilter(item, productTypes, activeTypes) {
    var typeKey = getWorkshopTypeKey(item, productTypes);
    if (!typeKey) return activeTypes.size === TYPE_ORDER.length;
    return activeTypes.has(typeKey);
  }

  function extractNumericEventId(val) {
    if (val == null) return '';
    var s = String(val).trim();
    if (!s) return '';
    var metaGid = /^gid:\/\/shopify\/Metaobject\/(\d+)$/i.exec(s);
    if (metaGid) return metaGid[1];
    if (/^\d+$/.test(s)) return s;
    return '';
  }

  function buildBookUrl(productUrl, eventId, venueHandle) {
    var base = (productUrl || '').trim();
    if (!base) return '#';
    try {
      var u = new URL(base, window.location.origin);
      var eid = extractNumericEventId(eventId);
      if (eid) u.searchParams.set('event_id', eid);
      if (venueHandle) u.searchParams.set('venue', venueHandle);
      return u.pathname + u.search;
    } catch (_) {
      var qs = [];
      var eid2 = extractNumericEventId(eventId);
      if (eid2) qs.push('event_id=' + encodeURIComponent(eid2));
      if (venueHandle) qs.push('venue=' + encodeURIComponent(venueHandle));
      return base + (base.indexOf('?') > -1 ? '&' : '?') + qs.join('&');
    }
  }

  function eventsBatchUrl() {
    var base = String((typeof window !== 'undefined' && window.__AOGEN_API_BASE__) || 'https://adapter.aogen.com.au').replace(
      /\/+$/,
      ''
    );
    return base + '/api/public/workshop-venue/events-batch';
  }

  function shopDomain() {
    return String((typeof window !== 'undefined' && window.Shopify && window.Shopify.shop) || '').trim();
  }

  function typeCollectionHandle(type) {
    if (type === 'mosaic') return 'mosaic-workshops';
    if (type === 'ceramic') return 'ceramic-workshops';
    if (type === 'resin') return 'resin-workshops';
    if (type === 'flower') return 'flower-workshops';
    return '';
  }

  function cityFromHandle(handle) {
    var h = String(handle || '').toLowerCase();
    var idx = h.lastIndexOf('-in-');
    if (idx === -1) return '';
    return h
      .slice(idx + 4)
      .split('-')
      .map(function (w) {
        if (!w) return '';
        if (w.length === 2) return w.toUpperCase();
        return w.charAt(0).toUpperCase() + w.slice(1);
      })
      .filter(Boolean)
      .join(' ');
  }

  /** City product titles read "<Workshop> in <City>"; fall back to the handle slug. */
  function cityFromProduct(product) {
    product = product || {};
    var title = String(product.title || '');
    var idx = title.toLowerCase().lastIndexOf(' in ');
    if (idx > 0) return title.slice(idx + 4).trim();
    return cityFromHandle(product.handle);
  }

  function coerceImageUrl(img) {
    if (img == null || img === '') return '';
    if (typeof img === 'object') {
      if (img.url) return String(img.url).trim();
      if (img.src) return String(img.src).trim();
    }
    return String(img).trim();
  }

  function normalizeVenueNameKey(name) {
    return String(name || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .replace(/[^\w\s\u0100-\u024f-]/g, '');
  }

  function venueImageLookupKeys(venue) {
    var v = venue && typeof venue === 'object' ? venue : {};
    var keys = [];
    var seen = Object.create(null);
    function pushKey(raw) {
      var s = String(raw == null ? '' : raw).trim();
      if (!s || seen[s]) return;
      seen[s] = true;
      keys.push(s);
    }
    function pushRef(raw) {
      var s = String(raw == null ? '' : raw).trim();
      if (!s) return;
      pushKey(s);
      var gidMatch = s.match(/Metaobject\/(\d+)/i);
      if (gidMatch) pushKey('gid://shopify/Metaobject/' + gidMatch[1]);
      if (/^\d+$/.test(s)) pushKey('gid://shopify/Metaobject/' + s);
      var tail = s.split('/').pop();
      if (tail && tail !== s) pushKey(tail);
    }
    pushRef(v.id);
    pushRef(v.venue_ref_id);
    pushRef(v.venue_metaobject_gid);
    var handle = (v.handle || v.venue_handle || '').toString().trim().toLowerCase();
    if (handle) pushKey(handle);
    var nameKey = normalizeVenueNameKey(v.venue_name || v.name || '');
    if (nameKey) pushKey(nameKey);
    var cityKey = normalizeVenueNameKey(v.city_name || v.city || '');
    if (cityKey) pushKey(cityKey);
    return keys;
  }

  function getVenueImageUrl(venue, venueImages) {
    var v = venue && typeof venue === 'object' ? venue : {};
    var url = coerceImageUrl(
      v.venue_image ||
        v.venueImage ||
        v.venue_image_url ||
        v.image ||
        v.image_url ||
        v.cover_image ||
        ''
    );
    if (url) return url;
    var images = venueImages && typeof venueImages === 'object' ? venueImages : {};
    var keys = venueImageLookupKeys(v);
    for (var i = 0; i < keys.length; i++) {
      if (images[keys[i]]) return images[keys[i]];
    }
    return '';
  }

  function renderVenueMedia(venue, venueImages) {
    var url = getVenueImageUrl(venue, venueImages);
    var name = ((venue && venue.venue_name) || 'Venue').toString();
    if (url) {
      return (
        '<div class="wec-event-card__media">' +
        '<img src="' +
        escAttr(url) +
        '" alt="' +
        escAttr(name) +
        '" loading="lazy" decoding="async">' +
        '</div>'
      );
    }
    return (
      '<div class="wec-event-card__media wec-event-card__media--empty" aria-hidden="true">' +
      '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">' +
      '<rect x="3" y="3" width="18" height="18" rx="2"/>' +
      '<circle cx="8.5" cy="8.5" r="1.5" fill="currentColor" stroke="none"/>' +
      '<path d="M21 15l-5-5L5 21"/>' +
      '</svg>' +
      '</div>'
    );
  }

  function formatVenueMeta(item) {
    var venue = (item && item.venue) || {};
    var parts = [];
    var city = (venue.city || '').toString().trim();
    var state = (venue.state || venue.state_code || '').toString().trim();
    var loc = [city, state].filter(Boolean).join(', ');
    if (loc) parts.push(loc);
    return parts.join(' • ');
  }

  function resolveFetchContext(root, config) {
    var lat = Number(root && root.getAttribute('data-wec-fetch-lat'));
    var lng = Number(root && root.getAttribute('data-wec-fetch-lng'));
    var radiusKm = Number(root && root.getAttribute('data-wec-fetch-radius-km'));

    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
      lat = Number(config && config.fallbackLat);
      lng = Number(config && config.fallbackLng);
    }
    if (!Number.isFinite(radiusKm) || radiusKm <= 0) {
      radiusKm = Number(config && config.fallbackRadiusKm);
    }

    if (lat === 43 && lng === -75) {
      lat = 39.833333;
      lng = -98.583333;
    }
    if (!Number.isFinite(radiusKm) || radiusKm <= 1000) {
      radiusKm = 2650;
    }

    return { lat: lat, lng: lng, radiusKm: radiusKm, label: '' };
  }

  function fetchEventsByVenue(lat, lng, radiusKm, proxyBase, eventsPath, productNames, productTypes, rangeStart, rangeEnd) {
    var shared = typeof window !== 'undefined' ? window.AMCWorkshopEventsV : null;
    var primaryPath = eventsPath || '/events-v';

    function parseGroups(data) {
      if (!data || !data.ok || !data.groups) return [];
      var events = [];
      data.groups.forEach(function (group) {
        (group.venues || []).forEach(function (venue) {
          (venue.events || []).forEach(function (ev) {
            var type = typeFromEvent(ev, productTypes);
            var catalogGid = gidForType(type, productTypes);
            var eventSelectionId = (
              ev.event_metaobject_gid ||
              ev.eventMetaobjectGid ||
              ev.metaobject_gid ||
              ev.id ||
              ev.event_id ||
              ''
            ).toString();
            events.push({
              event: ev,
              venue: venue,
              product_gid: catalogGid || ev.hub_product || ev.product_gid || '',
              product_name: (productNames && productNames[catalogGid]) || ev.product_title || 'Workshop',
              event_selection_id: eventSelectionId
            });
          });
        });
      });
      return events;
    }

    function load(path) {
      var req = {
        productGid: '',
        lat: lat,
        lng: lng,
        radiusKm: radiusKm,
        includeEmpty: false,
        proxyBase: proxyBase,
        eventsPath: path,
        startDate: rangeStart || '',
        endDate: rangeEnd || ''
      };
      if (shared && typeof shared.get === 'function') return shared.get(req);
      var url =
        proxyBase +
        path +
        '?lat=' +
        lat +
        '&lng=' +
        lng +
        '&radius_km=' +
        radiusKm;
      if (rangeStart && rangeEnd) {
        url += '&date_from=' + encodeURIComponent(rangeStart) + '&date_to=' + encodeURIComponent(rangeEnd);
      }
      return fetch(url).then(function (r) {
        if (!r.ok) throw new Error('events ' + r.status);
        return r.json();
      });
    }

    return load(primaryPath)
      .catch(function () {
        if (String(primaryPath).indexOf('calendar') === -1) return { ok: false, groups: [] };
        return load('/events-v');
      })
      .then(parseGroups)
      .catch(function () {
        return [];
      });
  }

  function getEventGroups(items) {
    var map = new Map();
    items.forEach(function (item) {
      var ev = item.event || {};
      var venue = item.venue || {};
      var dk = getEventDateKey(ev);
      var timeLabel = eventDisplayTime(ev);
      var startRaw = getEventStart(ev) || timeLabel || '';
      if (!dk || !timeLabel) return;
      var groupKey = [item.product_gid || '', venue.venue_name || '', venue.venue_address || '', dk].join('|');
      if (!map.has(groupKey)) {
        map.set(groupKey, {
          product_gid: item.product_gid || '',
          product_url: item.product_url || '',
          product_name: item.product_name || 'Workshop',
          venue: venue,
          dateObj: parseDateKey(dk),
          dateKey: dk,
          times: []
        });
      }
      map.get(groupKey).times.push({
        eventId: (item.event_selection_id || '').toString(),
        startRaw: startRaw,
        label: timeLabel,
        eventHandle: (ev.handle || ev.event_handle || '').toString().trim(),
        venueHandle: (venue.handle || venue.venue_handle || venue.venue_ref_id || '').toString().trim()
      });
    });

    var groups = Array.from(map.values());
    groups.forEach(function (g) {
      g.times.sort(function (a, b) {
        return String(a.startRaw || '').localeCompare(String(b.startRaw || ''));
      });
      var first = g.times[0] || {};
      g.selectedEventId = first.eventId || '';
      g.selectedStartRaw = first.startRaw || '';
      g.selectedVenueHandle = first.venueHandle || '';
    });
    groups.sort(function (a, b) {
      return String(a.selectedStartRaw || '').localeCompare(String(b.selectedStartRaw || ''));
    });
    return groups;
  }

  function initSection(root) {
    if (!root || root.__wecBound) return;

    var config = parseConfig(root) || {};
    var gids = Array.isArray(config.gids) ? config.gids.filter(Boolean) : [];
    var productNames = config.productNames || {};
    var productUrls = config.productUrls || {};
    var productTypes = config.productTypes || {};
    var venueImages = config.venueImages || {};
    var proxyBase = config.proxyBase || '/apps/workshop-events';
    var eventsPath = config.eventsPath || '/events-v';
    var citiesPerRow = Math.max(1, Number(config.citiesPerRow) || 2);
    var rowsPerPage = Math.max(1, Number(config.rowsPerPage) || 3);
    var mobileRowsPerPage = Math.max(1, Number(config.mobileRowsPerPage) || 3);
    var citiesPerPage = Math.max(
      1,
      Number(config.citiesPerPage) || rowsPerPage * citiesPerRow
    );
    var cardsPerVenue = Math.max(1, Number(config.cardsPerVenue) || 2);

    var heroEl = root.querySelector('.wec-hero');
    var filtersEl = root.querySelector('[data-wec-filters]');
    var startInput = root.querySelector('[data-wec-start-input]');
    var endInput = root.querySelector('[data-wec-end-input]');
    var calPopup = root.querySelector('[data-wec-cal-popup]');
    var calOpenBtn = root.querySelector('[data-wec-cal-open]');
    var calendarEl = root.querySelector('[data-wec-calendar]');
    var listEl = root.querySelector('[data-wec-list]');
    var paginationEl = root.querySelector('[data-wec-pagination]');

    var allEvents = [];
    var activeTypes = new Set(TYPE_ORDER.slice());
    var rangeStart = '';
    var rangeEnd = '';
    var calPickTarget = 'range';
    var calendarCursor = null;
    var currentCityPage = 1;
    var venueCarouselOffsets = {};
    var mobileListMinHeight = 0;
    var isFetching = false;
    var cityProductIndex = null;
    var cityProductsCache = {};
    var venueDirectoryCache = null;

    function totalCityPages(cityCount) {
      return Math.max(1, Math.ceil(cityCount / getActiveCitiesPerPage()));
    }

    function resetCityPagination() {
      currentCityPage = 1;
      resetMobileListHeightLock();
    }

    function getActiveCitiesPerPage() {
      var mobile = typeof window !== 'undefined' && window.matchMedia('(max-width: 749px)').matches;
      if (mobile) return mobileRowsPerPage;
      return citiesPerPage;
    }

    function isMobileViewport() {
      return typeof window !== 'undefined' && window.matchMedia('(max-width: 749px)').matches;
    }

    function resetMobileListHeightLock() {
      mobileListMinHeight = 0;
      if (listEl) listEl.style.minHeight = '';
    }

    function updateMobileListHeightLock() {
      if (!listEl) return;
      if (!isMobileViewport()) {
        listEl.style.minHeight = '';
        return;
      }
      var nextHeight = Math.ceil(listEl.getBoundingClientRect().height);
      if (!nextHeight) return;
      if (nextHeight > mobileListMinHeight) mobileListMinHeight = nextHeight;
      if (mobileListMinHeight > 0) listEl.style.minHeight = mobileListMinHeight + 'px';
    }

    function resetVenueCarouselOffsets() {
      venueCarouselOffsets = {};
    }

    function clampVenueCarouselOffset(clusterKey, cardCount) {
      var offset = venueCarouselOffsets[clusterKey] || 0;
      var maxOffset = Math.max(0, cardCount - cardsPerVenue);
      if (offset > maxOffset) offset = maxOffset;
      venueCarouselOffsets[clusterKey] = offset;
      return offset;
    }

    function defaultRange() {
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      var end = new Date(today);
      end.setDate(end.getDate() + 90);
      rangeStart = toDateKey(today);
      rangeEnd = toDateKey(end);
      calendarCursor = new Date(today.getFullYear(), today.getMonth(), 1);
    }

    function updateDateDisplays() {
      if (startInput) {
        startInput.value = rangeStart ? formatDisplayDate(rangeStart) : '';
      }
      if (endInput) {
        endInput.value = rangeEnd ? formatDisplayDate(rangeEnd) : '';
      }
    }

    function normalizeDateRange() {
      if (!rangeStart) {
        rangeEnd = '';
        return;
      }
      if (rangeStart && rangeEnd && rangeEnd < rangeStart) {
        rangeEnd = rangeStart;
      }
    }

    function applyDateInputs(triggerFetch) {
      if (startInput) {
        if (!startInput.value.trim()) rangeStart = '';
        else {
          var startParsed = parseFlexibleDate(startInput.value);
          if (startParsed) rangeStart = startParsed;
        }
      }
      if (endInput) {
        if (!endInput.value.trim()) rangeEnd = '';
        else {
          var endParsed = parseFlexibleDate(endInput.value);
          if (endParsed) rangeEnd = endParsed;
        }
      }
      normalizeDateRange();
      updateDateDisplays();
      if (triggerFetch) fetchAll();
      else if (allEvents.length) renderList();
    }

    function closeCalPopup() {
      if (calPopup) calPopup.hidden = true;
      if (calOpenBtn) calOpenBtn.classList.remove('is-open');
      calPickTarget = 'range';
    }

    function positionCalPopup(anchorBtn) {
      if (!calPopup || !anchorBtn || !heroEl) return;
      var btnRect = anchorBtn.getBoundingClientRect();
      var panel = calPopup.querySelector('.wec-cal-popup__panel');
      var panelHeight = (panel && panel.offsetHeight) || 320;
      var gutter = 8;
      var mobile = window.matchMedia('(max-width: 749px)').matches;

      if (mobile) {
        var top = btnRect.bottom + 8;
        if (top + panelHeight > window.innerHeight - gutter) {
          top = Math.max(gutter, window.innerHeight - panelHeight - gutter);
        }
        calPopup.style.left = '12px';
        calPopup.style.right = '12px';
        calPopup.style.top = top + 'px';
        return;
      }

      var heroRect = heroEl.getBoundingClientRect();
      var panelWidth = (panel && panel.offsetWidth) || 300;
      var desiredLeft = btnRect.left - heroRect.left;
      var minLeft = gutter;
      var maxLeft = Math.max(minLeft, heroRect.width - panelWidth - gutter);
      var left = Math.min(maxLeft, Math.max(minLeft, desiredLeft));
      var topBelow = btnRect.bottom - heroRect.top + 8;
      var topAbove = btnRect.top - heroRect.top - panelHeight - 8;
      var topDesk = topBelow;
      if (btnRect.bottom + panelHeight > window.innerHeight - 8 && topAbove >= gutter) {
        topDesk = topAbove;
      }
      calPopup.style.left = Math.max(gutter, left) + 'px';
      calPopup.style.right = 'auto';
      calPopup.style.top = Math.max(gutter, topDesk) + 'px';
    }

    function openCalPopup(anchorBtn, pickTarget) {
      calPickTarget = pickTarget || 'range';
      var seed =
        calPickTarget === 'end'
          ? parseDateKey(rangeEnd) || parseDateKey(rangeStart) || new Date()
          : parseDateKey(rangeStart) || parseDateKey(rangeEnd) || new Date();
      calendarCursor = ensureCalendarCursor(null, seed);
      if (calPopup) calPopup.hidden = false;
      if (calOpenBtn) calOpenBtn.classList.toggle('is-open', anchorBtn === calOpenBtn);
      renderCalendar();
      positionCalPopup(anchorBtn || calOpenBtn);
    }

    function isInRange(dateKey) {
      if (!dateKey) return false;
      if (rangeStart && dateKey < rangeStart) return false;
      if (rangeEnd && dateKey > rangeEnd) return false;
      return true;
    }

    function dayInRangeVisual(dateKey) {
      if (!rangeStart || !rangeEnd || !dateKey) return false;
      return dateKey >= rangeStart && dateKey <= rangeEnd;
    }

    function renderCalendar() {
      if (!calendarEl) return;
      var seed = parseDateKey(rangeStart) || parseDateKey(rangeEnd) || new Date();
      calendarCursor = ensureCalendarCursor(calendarCursor, seed);
      var year = calendarCursor.getFullYear();
      var month = calendarCursor.getMonth();
      var firstDay = new Date(year, month, 1);
      var lastDay = new Date(year, month + 1, 0);
      var leading = (firstDay.getDay() + 6) % 7;
      var daysInMonth = lastDay.getDate();
      if (!Number.isFinite(daysInMonth) || daysInMonth < 1) {
        calendarCursor = ensureCalendarCursor(null, new Date());
        year = calendarCursor.getFullYear();
        month = calendarCursor.getMonth();
        firstDay = new Date(year, month, 1);
        lastDay = new Date(year, month + 1, 0);
        leading = (firstDay.getDay() + 6) % 7;
        daysInMonth = lastDay.getDate();
      }
      var totalSlots = Math.ceil((leading + daysInMonth) / 7) * 7;
      var weekdays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
      var todayKey = toDateKey(new Date());
      var yearBounds = getCalendarYearBounds();

      var monthOptions = MONTH_NAMES.map(function (name, idx) {
        return (
          '<option value="' +
          idx +
          '"' +
          (idx === month ? ' selected' : '') +
          '>' +
          escHtml(name) +
          '</option>'
        );
      }).join('');

      var yearOptions = '';
      for (var y = yearBounds.min; y <= yearBounds.max; y++) {
        yearOptions +=
          '<option value="' + y + '"' + (y === year ? ' selected' : '') + '>' + y + '</option>';
      }

      var dayHtml = '';
      for (var i = 0; i < totalSlots; i++) {
        if (i < leading || i >= leading + daysInMonth) {
          dayHtml += '<div class="wec-cal-cell--empty" aria-hidden="true"></div>';
          continue;
        }
        var dayNum = i - leading + 1;
        var d = new Date(year, month, dayNum);
        var dk = toDateKey(d);
        var cls = 'wec-cal-day';
        var isPast = dk < todayKey;
        if (isPast) cls += ' wec-cal-day--muted';
        if (dayInRangeVisual(dk)) cls += ' wec-cal-day--in-range';
        if (rangeStart && dk === rangeStart) cls += ' wec-cal-day--range-start';
        if (rangeEnd && dk === rangeEnd) cls += ' wec-cal-day--range-end';
        if (rangeStart && !rangeEnd && dk === rangeStart) cls += ' wec-cal-day--selected';
        dayHtml +=
          '<button type="button" class="' +
          cls +
          '" data-wec-cal-day="' +
          escAttr(dk) +
          '"' +
          (isPast ? ' data-wec-past="true" tabindex="-1"' : '') +
          '>' +
          dayNum +
          '</button>';
      }

      calendarEl.innerHTML =
        '<div class="wec-cal-header">' +
        '<button type="button" class="wec-cal-nav" data-wec-cal-nav="prev" aria-label="Previous month">&lt;</button>' +
        '<div class="wec-cal-controls">' +
        '<select class="wec-cal-select" data-wec-cal-month aria-label="Month">' +
        monthOptions +
        '</select>' +
        '<select class="wec-cal-select" data-wec-cal-year aria-label="Year">' +
        yearOptions +
        '</select>' +
        '</div>' +
        '<button type="button" class="wec-cal-nav" data-wec-cal-nav="next" aria-label="Next month">&gt;</button>' +
        '</div>' +
        '<div class="wec-cal-weekdays">' +
        weekdays
          .map(function (w) {
            return '<span class="wec-cal-weekday">' + w + '</span>';
          })
          .join('') +
        '</div>' +
        '<div class="wec-cal-grid">' +
        dayHtml +
        '</div>';
    }

    function onCalendarDayClick(dateKey) {
      if (!dateKey) return;
      if (calPickTarget === 'start') {
        rangeStart = dateKey;
        if (rangeEnd && rangeEnd < rangeStart) rangeEnd = rangeStart;
        normalizeDateRange();
        updateDateDisplays();
        closeCalPopup();
        fetchAll();
        return;
      }
      if (calPickTarget === 'end') {
        rangeEnd = dateKey;
        if (rangeStart && rangeEnd < rangeStart) rangeStart = rangeEnd;
        normalizeDateRange();
        updateDateDisplays();
        closeCalPopup();
        fetchAll();
        return;
      }
      if (!rangeStart || (rangeStart && rangeEnd)) {
        rangeStart = dateKey;
        rangeEnd = '';
        normalizeDateRange();
        updateDateDisplays();
        renderCalendar();
        return;
      }
      if (dateKey < rangeStart) {
        rangeStart = dateKey;
        rangeEnd = '';
        updateDateDisplays();
        renderCalendar();
        return;
      }
      rangeEnd = dateKey;
      normalizeDateRange();
      updateDateDisplays();
      closeCalPopup();
      fetchAll();
    }

    function syncFilterPills() {
      if (!filtersEl) return;
      var allSelected = activeTypes.size === TYPE_ORDER.length;
      filtersEl.querySelectorAll('[data-wec-filter]').forEach(function (btn) {
        var key = (btn.getAttribute('data-wec-filter') || '').toLowerCase();
        var on = key === 'all' ? allSelected : !allSelected && activeTypes.has(key);
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    function renderSkeleton() {
      var perPage = getActiveCitiesPerPage();
      var cardCount = Math.max(1, cardsPerVenue);
      var groups = '';
      for (var i = 0; i < perPage; i++) {
        var cards = '';
        for (var c = 0; c < cardCount; c++) {
          cards +=
            '<div class="wec-skel-card">' +
            '<div class="wec-skel-card__body">' +
            '<div class="wec-skel-line wec-skel-line--date"></div>' +
            '<div class="wec-skel-line wec-skel-line--type"></div>' +
            '<div class="wec-skel-times"><span></span><span></span></div>' +
            '</div>' +
            '<div class="wec-skel-card__media"></div>' +
            '</div>';
        }
        groups +=
          '<section class="wec-venue-group wec-skel-group">' +
          '<header class="wec-venue-group__head">' +
          '<div class="wec-skel-line wec-skel-line--title"></div>' +
          '<div class="wec-skel-line wec-skel-line--meta"></div>' +
          '</header>' +
          '<div class="wec-venue-group__carousel">' +
          '<div class="wec-venue-group__grid">' +
          cards +
          '</div>' +
          '</div>' +
          '</section>';
      }
      return '<div class="wec-venue-groups wec-skel-groups" aria-hidden="true">' + groups + '</div>';
    }

    function setLoading(on) {
      if (!listEl) return;
      if (on) {
        resetMobileListHeightLock();
        listEl.setAttribute('aria-busy', 'true');
        listEl.innerHTML = renderSkeleton();
      } else {
        listEl.removeAttribute('aria-busy');
      }
    }

    function readVenueDirectory() {
      if (venueDirectoryCache) return venueDirectoryCache;
      var map = Object.create(null);
      var el = root.querySelector('[data-wec-venues]') || document.querySelector('[data-wef-venues]');
      if (el && el.textContent) {
        try {
          var rows = JSON.parse(el.textContent);
          if (Array.isArray(rows)) {
            rows.forEach(function (row) {
              var key = String((row && row.venue_ref_id) || '').trim();
              if (key) map[key] = row;
            });
          }
        } catch (e) {}
      }
      venueDirectoryCache = map;
      return map;
    }

    /* The section renders the city product index server-side; products.json would ship
       ~1MB per collection for the same three fields. `count` detects a truncated page. */
    function readRenderedCityProducts(type) {
      if (cityProductIndex === null) {
        cityProductIndex = {};
        var el = root.querySelector('[data-wec-city-products]') || document.querySelector('[data-wef-city-products]');
        if (el && el.textContent) {
          try {
            cityProductIndex = JSON.parse(el.textContent) || {};
          } catch (e) {}
        }
      }
      var entry = cityProductIndex[type];
      if (!entry || !Array.isArray(entry.products) || !entry.products.length) return null;
      if (Number(entry.count) > entry.products.length) return null;
      return entry.products;
    }

    function mapCityProducts(rows) {
      return rows.map(function (p) {
        return {
          gid: 'gid://shopify/Product/' + p.id,
          handle: p.handle,
          title: p.title,
          city: cityFromProduct(p)
        };
      });
    }

    function fetchCityProducts(type) {
      if (cityProductsCache[type]) return Promise.resolve(cityProductsCache[type]);

      var rendered = readRenderedCityProducts(type);
      if (rendered) {
        cityProductsCache[type] = mapCityProducts(rendered);
        return Promise.resolve(cityProductsCache[type]);
      }

      var handle = typeCollectionHandle(type);
      if (!handle) return Promise.resolve([]);
      return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=250&page=1', {
        credentials: 'same-origin'
      })
        .then(function (res) {
          if (!res.ok) throw new Error('city_products ' + res.status);
          return res.json();
        })
        .then(function (body) {
          cityProductsCache[type] = mapCityProducts((body && body.products) || []);
          return cityProductsCache[type];
        })
        .catch(function () {
          return [];
        });
    }

    /* events-batch caps a request at 500 slots, so keep chunks small — a single store venue
       can carry ~200 sessions in a 90-day window. */
    function fetchEventsBatch(products, type) {
      var byGid = {};
      products.forEach(function (p) {
        byGid[p.gid] = p;
      });

      var CHUNK = 24;
      var chunks = [];
      var i;
      for (i = 0; i < products.length; i += CHUNK) {
        chunks.push(
          products.slice(i, i + CHUNK).map(function (p) {
            return p.gid;
          })
        );
      }
      if (!chunks.length) return Promise.resolve({ items: [], ok: false });

      var catalogGid = gidForType(type, productTypes);
      var directory = readVenueDirectory();

      return Promise.all(
        chunks.map(function (chunkGids) {
          return fetch(eventsBatchUrl(), {
            method: 'POST',
            credentials: 'omit',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              shop_domain: shopDomain(),
              product_gids: chunkGids,
              date_from: rangeStart,
              date_to: rangeEnd
            })
          })
            .then(function (res) {
              return res.json();
            })
            .catch(function () {
              return null;
            });
        })
      ).then(function (bodies) {
        var items = [];
        var seen = Object.create(null);
        var responded = false;
        bodies.forEach(function (body) {
          if (!body || !Array.isArray(body.products)) return;
          responded = true;
          body.products.forEach(function (row) {
            var product = byGid[String(row.product_gid || '')] || {};
            var handle = String(row.product_handle || product.handle || '').trim();
            var city = product.city || cityFromHandle(handle);
            (row.slots || []).forEach(function (slot) {
              if (!slot) return;
              var eventId = String(slot.event_id || slot.canonical_event_id || '');
              if (!eventId || seen[eventId + '|' + handle]) return;
              seen[eventId + '|' + handle] = true;

              var venueRefId = String(slot.venue_ref_id || '').trim();
              var dirRow = directory[venueRefId] || {};
              var ev = {
                id: eventId,
                date_key: slot.date_key,
                starts_at: slot.starts_at,
                time_label: slot.time_label,
                status: slot.status || 'active',
                capacity_remaining: slot.capacity_remaining,
                price_display: slot.price_display,
                venue_ref_id: venueRefId,
                venue_name: dirRow.venue_name || city,
                venue_address: dirRow.venue_address || '',
                city: city,
                state_code: dirRow.state_code || '',
                product_gid: catalogGid || '',
                product_handle: handle,
                product_title: product.title || '',
                event_name: city || 'Workshop Session'
              };
              if (!eventDisplayTime(ev) || !getEventDateKey(ev)) return;

              items.push({
                event: ev,
                venue: {
                  venue_ref_id: venueRefId,
                  venue_name: ev.venue_name,
                  venue_handle: '',
                  venue_address: ev.venue_address,
                  city_key: '',
                  city: city,
                  state_code: ev.state_code
                },
                product_gid: catalogGid || '',
                product_name: (productNames && productNames[catalogGid]) || product.title || 'Workshop',
                product_url: handle ? '/products/' + handle : '',
                event_selection_id: eventId
              });
            });
          });
        });
        return { items: items, ok: responded };
      });
    }

    /* Venue×type products are the source of truth since the venue-products gate went on —
       hub GIDs no longer carry events, so query the per-city products instead. */
    function fetchVenueProductEvents() {
      var types = [];
      Object.keys(productTypes || {}).forEach(function (gid) {
        var type = productTypes[gid];
        if (type && types.indexOf(type) === -1) types.push(type);
      });
      if (!types.length || !rangeStart || !rangeEnd) return Promise.resolve({ items: [], ok: false });

      return Promise.all(
        types.map(function (type) {
          return fetchCityProducts(type).then(function (products) {
            if (!products.length) return { items: [], ok: false };
            return fetchEventsBatch(products, type);
          });
        })
      ).then(function (results) {
        var items = [];
        var ok = false;
        results.forEach(function (res) {
          if (res.ok) ok = true;
          items = items.concat(res.items);
        });
        return { items: items, ok: ok };
      });
    }

    function collectThemeEvents() {
      var events = [];
      readThemeEventRows().forEach(function (ev) {
        if (!ev || typeof ev !== 'object') return;
        if (!eventDisplayTime(ev) || !getEventDateKey(ev)) return;
        var type = typeFromEvent(ev, productTypes);
        var catalogGid = gidForType(type, productTypes);
        events.push({
          event: ev,
          venue: {
            venue_ref_id: String(ev.venue_ref_id || '').trim(),
            venue_name: ev.venue_name || '',
            venue_handle: ev.venue_handle || '',
            venue_address: ev.venue_address || '',
            city_key: ev.city_key || '',
            city: ev.city || '',
            state_code: ev.state_code || ''
          },
          product_gid: catalogGid || '',
          product_name: (productNames && productNames[catalogGid]) || ev.event_name || 'Workshop',
          product_url: '',
          event_selection_id: String(ev.id || '')
        });
      });
      return events;
    }

    function fetchAll() {
      if (isFetching) return Promise.resolve();
      if (!gids.length) {
        if (listEl) {
          listEl.innerHTML =
            '<div class="wec-empty">' +
            escHtml(config.noCollectionLabel || 'Choose a workshop collection in section settings.') +
            '</div>';
        }
        return Promise.resolve();
      }
      isFetching = true;
      setLoading(true);
      return fetchVenueProductEvents()
        .catch(function () {
          return { items: [], ok: false };
        })
        .then(function (batch) {
          allEvents = batch.ok && batch.items.length ? batch.items : collectThemeEvents();
          allEvents.sort(function (a, b) {
            return String(getEventStart(a.event) || '').localeCompare(String(getEventStart(b.event) || ''));
          });
          resetCityPagination();
          resetVenueCarouselOffsets();
          renderList();
        })
        .catch(function () {
          if (listEl) {
            listEl.removeAttribute('aria-busy');
            listEl.innerHTML =
              '<div class="wec-empty">' + escHtml(config.errorLabel || "Couldn't load sessions. Try again.") + '</div>';
          }
        })
        .finally(function () {
          isFetching = false;
        });
    }

    var lastCityCount = 0;

    function paintCityPagination(totalPages, activeCitiesPerPage, cityCount) {
      if (!paginationEl) return;
      lastCityCount = cityCount;
      if (cityCount <= activeCitiesPerPage) {
        paginationEl.innerHTML = '';
        paginationEl.hidden = true;
        return;
      }
      paginationEl.hidden = false;
      var nums = '';
      for (var n = 1; n <= totalPages; n++) {
        var isActive = n === currentCityPage;
        nums +=
          '<button type="button" class="wec-page-btn' +
          (isActive ? ' is-active' : '') +
          '" data-wec-city-page="' +
          n +
          '"' +
          (isActive ? ' aria-current="page"' : '') +
          '>' +
          n +
          '</button>';
      }
      paginationEl.innerHTML =
        '<div class="wec-pagination-inner" role="navigation" aria-label="City pages">' +
        '<button type="button" class="wec-page-btn wec-page-btn--nav" data-wec-city-page="prev" aria-label="Previous page"' +
        (currentCityPage <= 1 ? ' disabled' : '') +
        '>&lsaquo;</button>' +
        '<div class="wec-pagination-track">' +
        nums +
        '</div>' +
        '<button type="button" class="wec-page-btn wec-page-btn--nav" data-wec-city-page="next" aria-label="Next page"' +
        (currentCityPage >= totalPages ? ' disabled' : '') +
        '>&rsaquo;</button></div>';
      var track = paginationEl.querySelector('.wec-pagination-track');
      var activeBtn = track && track.querySelector('.is-active');
      if (track && activeBtn && track.scrollWidth > track.clientWidth) {
        track.scrollLeft = activeBtn.offsetLeft - (track.clientWidth - activeBtn.offsetWidth) / 2;
      }
    }

    function renderList() {
      if (!listEl) return;
      listEl.removeAttribute('aria-busy');
      var filtered = allEvents.filter(function (item) {
        var dk = getEventDateKey(item.event);
        return matchesTypeFilter(item, productTypes, activeTypes) && isInRange(dk) && !!eventDisplayTime(item.event);
      });

      var grouped = getEventGroups(filtered);
      var allVenueClusters = clusterByVenue(grouped);
      if (!allVenueClusters.length) {
        resetMobileListHeightLock();
        listEl.innerHTML =
          '<div class="wec-empty">' +
          escHtml(config.emptyLabel || 'New nights are landing — try another week or tap a pin on the map.') +
          '</div>';
        if (paginationEl) {
          paginationEl.innerHTML = '';
          paginationEl.hidden = true;
        }
        lastCityCount = 0;
        return;
      }

      var totalPages = totalCityPages(allVenueClusters.length);
      var activeCitiesPerPage = getActiveCitiesPerPage();
      if (currentCityPage > totalPages) currentCityPage = totalPages;
      var pageStart = (currentCityPage - 1) * activeCitiesPerPage;
      var venueClusters = allVenueClusters.slice(pageStart, pageStart + activeCitiesPerPage);

      function renderEventCard(item, hidden) {
        var d = item.dateObj;
        var eventSelectionId = (item.selectedEventId || '').toString();
        var timesArr = (item.times || []).slice(0, 4);
        var activeSlot = timesArr[0] || {};
        var venueHandle = (activeSlot.venueHandle || '').toString();
        /* Venue product PDPs already resolve the city, so the venue param is hub-only. */
        var productUrl = item.product_url || productUrls[item.product_gid] || '';
        var bookUrl = buildBookUrl(productUrl, eventSelectionId, item.product_url ? '' : venueHandle);
        var dateDay = d ? formatDay(d) : escHtml(((item.venue && (item.venue.city || item.venue.venue_name)) || '').toString().slice(0, 8));
        var dateMonth = d ? formatMonth(d) : '';

        var timesClass =
          timesArr.length > 2 ? ' wec-event-card__times wec-event-card__times--multi' : ' wec-event-card__times';
        var timesHtml =
          '<div class="' +
          timesClass.trim() +
          '" data-wec-event-times>' +
          timesArr
            .map(function (slot, idx) {
              var activeCls = idx === 0 ? ' is-active' : '';
              return (
                '<button type="button" class="wec-event-time-btn' +
                activeCls +
                '" data-time-event-id="' +
                escAttr(slot.eventId || '') +
                '" data-time-venue="' +
                escAttr(slot.venueHandle || '') +
                '">' +
                escHtml(slot.label || '') +
                '</button>'
              );
            })
            .join('') +
          '</div>';

        return (
          '<a class="wec-event-card"' +
          (hidden ? ' hidden' : '') +
          ' href="' +
          escAttr(bookUrl) +
          '" data-wec-event-card data-product-url="' +
          escAttr(productUrl) +
          '" data-event-id="' +
          escAttr(eventSelectionId) +
          '">' +
          '<div class="wec-event-card__body">' +
          '<div class="wec-event-card__date">' +
          '<span class="wec-event-card__date-day">' +
          dateDay +
          '</span>' +
          '<span class="wec-event-card__date-month">' +
          dateMonth +
          '</span>' +
          '</div>' +
          '<p class="wec-event-card__type">' +
          escHtml(item.product_name || 'Workshop') +
          '</p>' +
          timesHtml +
          '</div>' +
          renderVenueMedia(item.venue, venueImages) +
          '</a>'
        );
      }

      function renderVenueCarousel(cluster) {
        var cards = cluster.cards || [];
        var isPassive = cards.length <= cardsPerVenue;
        var offset = isPassive ? 0 : clampVenueCarouselOffset(cluster.key, cards.length);
        var maxOffset = Math.max(0, cards.length - cardsPerVenue);
        var cardsHtml = cards
          .map(function (item, idx) {
            var isVisible = isPassive || (idx >= offset && idx < offset + cardsPerVenue);
            return renderEventCard(item, !isVisible);
          })
          .join('');

        var navPrev =
          '<button type="button" class="wec-venue-nav wec-venue-nav--prev' +
          (isPassive ? ' is-passive' : '') +
          '" data-wec-venue-prev data-cluster-key="' +
          escAttr(cluster.key) +
          '" aria-label="Previous sessions"' +
          (isPassive || offset <= 0 ? ' disabled' : '') +
          '><span aria-hidden="true">&lsaquo;</span></button>';

        var navNext =
          '<button type="button" class="wec-venue-nav wec-venue-nav--next' +
          (isPassive ? ' is-passive' : '') +
          '" data-wec-venue-next data-cluster-key="' +
          escAttr(cluster.key) +
          '" aria-label="Next sessions"' +
          (isPassive || offset >= maxOffset ? ' disabled' : '') +
          '><span aria-hidden="true">&rsaquo;</span></button>';

        return (
          '<div class="wec-venue-group__carousel">' +
          navPrev +
          '<div class="wec-venue-group__grid">' +
          cardsHtml +
          '</div>' +
          navNext +
          '</div>'
        );
      }

      listEl.innerHTML =
        '<div class="wec-venue-groups">' +
        venueClusters
          .map(function (cluster) {
            var colors = venueColorForKey(cluster.key);
            var venue = cluster.venue || {};
            var venueMeta = formatVenueMeta({ venue: venue });
            return (
              '<section class="wec-venue-group" style="--wec-card-bg:' +
              escAttr(colors.bg) +
              ';--wec-card-border:' +
              escAttr(colors.border) +
              ';--wec-card-text:' +
              escAttr(colors.text) +
              '">' +
              '<header class="wec-venue-group__head">' +
              '<h3 class="wec-venue-group__title">' +
              escHtml(venue.venue_name || 'Venue') +
              '</h3>' +
              (venueMeta ? '<span class="wec-venue-group__meta">' + escHtml(venueMeta) + '</span>' : '') +
              '</header>' +
              renderVenueCarousel(cluster) +
              '</section>'
            );
          })
          .join('') +
        '</div>';
      updateMobileListHeightLock();

      listEl.querySelectorAll('.wec-event-card__media img').forEach(function (img) {
        if (img.complete && img.naturalWidth > 0) {
          img.classList.add('is-loaded');
          return;
        }
        img.addEventListener('load', function () {
          img.classList.add('is-loaded');
        }, { once: true });
        img.addEventListener('error', function () {
          img.classList.add('is-loaded');
        }, { once: true });
      });

      listEl.querySelectorAll('.wec-event-time-btn').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var card = btn.closest('[data-wec-event-card]');
          if (!card) return;
          card.querySelectorAll('.wec-event-time-btn').forEach(function (other) {
            other.classList.remove('is-active');
          });
          btn.classList.add('is-active');
          var eid = btn.getAttribute('data-time-event-id') || '';
          var vh = btn.getAttribute('data-time-venue') || '';
          var purl = card.getAttribute('data-product-url') || '';
          card.setAttribute('data-event-id', eid);
          card.setAttribute('href', buildBookUrl(purl, eid, vh));
        });
      });

      paintCityPagination(totalPages, activeCitiesPerPage, allVenueClusters.length);
    }

    if (paginationEl && !paginationEl.__wecCityPageBound) {
      paginationEl.__wecCityPageBound = true;
      paginationEl.addEventListener('click', function (e) {
        var pageBtn = e.target.closest('[data-wec-city-page]');
        if (!pageBtn) return;
        e.preventDefault();
        var rawPage = pageBtn.getAttribute('data-wec-city-page');
        var page = currentCityPage;
        if (rawPage === 'prev') page = currentCityPage - 1;
        else if (rawPage === 'next') page = currentCityPage + 1;
        else page = Number(rawPage) || 1;
        var maxPage = totalCityPages(lastCityCount);
        if (page < 1 || page > maxPage || page === currentCityPage) return;
        currentCityPage = page;
        resetVenueCarouselOffsets();
        renderList();
        if (listEl && typeof listEl.scrollIntoView === 'function') {
          listEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    }

    if (listEl && !listEl.__wecCarouselBound) {
      listEl.__wecCarouselBound = true;
      listEl.addEventListener('click', function (e) {
        var prevBtn = e.target.closest('[data-wec-venue-prev]');
        var nextBtn = e.target.closest('[data-wec-venue-next]');
        if (!prevBtn && !nextBtn) return;
        e.preventDefault();
        var btn = prevBtn || nextBtn;
        if (btn.disabled) return;
        var key = btn.getAttribute('data-cluster-key') || '';
        if (!key) return;
        venueCarouselOffsets[key] = Math.max(0, (venueCarouselOffsets[key] || 0) + (prevBtn ? -1 : 1));
        renderList();
      });
    }

    function bindDateFieldCalendar(input, pickTarget) {
      if (!input) return;
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          applyDateInputs(true);
        }
      });
      input.addEventListener('blur', function () {
        applyDateInputs(true);
      });
      input.addEventListener('click', function (e) {
        e.stopPropagation();
        openCalPopup(input, pickTarget);
      });
      input.addEventListener('focus', function () {
        openCalPopup(input, pickTarget);
      });
    }
    bindDateFieldCalendar(startInput, 'start');
    bindDateFieldCalendar(endInput, 'end');

    root.addEventListener('change', function (e) {
      if (!calendarEl || !calPopup || calPopup.hidden) return;
      if (e.target.matches('[data-wec-cal-month]')) {
        calendarCursor = ensureCalendarCursor(
          new Date(calendarCursor.getFullYear(), Number(e.target.value), 1),
          new Date()
        );
        renderCalendar();
        return;
      }
      if (e.target.matches('[data-wec-cal-year]')) {
        calendarCursor = ensureCalendarCursor(
          new Date(Number(e.target.value), calendarCursor.getMonth(), 1),
          new Date()
        );
        renderCalendar();
      }
    });

    root.addEventListener('click', function (e) {
      var calOpenBtn = e.target.closest('[data-wec-cal-open]');
      if (calOpenBtn) {
        e.stopPropagation();
        if (calPopup && !calPopup.hidden) {
          closeCalPopup();
        } else {
          openCalPopup(calOpenBtn);
        }
        return;
      }

      var pill = e.target.closest('[data-wec-filter]');
      if (pill && filtersEl && filtersEl.contains(pill)) {
        closeCalPopup();
        pill.classList.add('is-tapped');
        window.setTimeout(function () {
          pill.classList.remove('is-tapped');
        }, 240);
        var key = (pill.getAttribute('data-wec-filter') || '').toLowerCase();
        if (key === 'all') {
          activeTypes = new Set(TYPE_ORDER.slice());
        } else if (activeTypes.size === TYPE_ORDER.length) {
          activeTypes = new Set([key]);
        } else if (activeTypes.has(key) && activeTypes.size === 1) {
          activeTypes = new Set(TYPE_ORDER.slice());
        } else {
          activeTypes = new Set([key]);
        }
        syncFilterPills();
        resetCityPagination();
        renderList();
        return;
      }

      var nav = e.target.closest('[data-wec-cal-nav]');
      if (nav && calendarEl && calendarEl.contains(nav)) {
        e.preventDefault();
        e.stopPropagation();
        var dir = nav.getAttribute('data-wec-cal-nav') === 'prev' ? -1 : 1;
        if (!calendarCursor) calendarCursor = new Date();
        calendarCursor = ensureCalendarCursor(
          new Date(calendarCursor.getFullYear(), calendarCursor.getMonth() + dir, 1),
          new Date()
        );
        renderCalendar();
        return;
      }

      var dayBtn = e.target.closest('[data-wec-cal-day]');
      if (dayBtn && calendarEl && calendarEl.contains(dayBtn) && !dayBtn.classList.contains('wec-cal-day--muted')) {
        e.stopPropagation();
        onCalendarDayClick(dayBtn.getAttribute('data-wec-cal-day'));
        return;
      }

      if (
        calPopup &&
        !calPopup.hidden &&
        !calPopup.contains(e.target) &&
        !e.target.closest('[data-wec-start-input]') &&
        !e.target.closest('[data-wec-end-input]') &&
        !e.target.closest('[data-wec-cal-open]')
      ) {
        closeCalPopup();
      }
    });

    root.__wecBound = true;

    defaultRange();
    updateDateDisplays();
    syncFilterPills();
    var sharedLazy = typeof window !== 'undefined' ? window.AMCWorkshopEventsV : null;
    function startCalendarFetch() {
      fetchAll();
    }
    if (sharedLazy && typeof sharedLazy.whenNearOrIdle === 'function') {
      sharedLazy.whenNearOrIdle(root, startCalendarFetch, { leadPx: 1400, idleMs: 800 });
    } else if (sharedLazy && typeof sharedLazy.whenNearViewport === 'function') {
      sharedLazy.whenNearViewport(root, startCalendarFetch, { leadPx: 1400 });
    } else {
      startCalendarFetch();
    }

    if (typeof window !== 'undefined') {
      var mobileMq = window.matchMedia('(max-width: 749px)');
      var lastMobileLayout = mobileMq.matches;
      function onViewportLayoutChange() {
        var isMobile = mobileMq.matches;
        if (isMobile === lastMobileLayout) return;
        lastMobileLayout = isMobile;
        resetCityPagination();
        renderList();
      }
      if (typeof mobileMq.addEventListener === 'function') {
        mobileMq.addEventListener('change', onViewportLayoutChange);
      } else       if (typeof mobileMq.addListener === 'function') {
        mobileMq.addListener(onViewportLayoutChange);
      }
    }

    if (typeof window !== 'undefined') {
      window.__WEC_refetch = function () {
        return fetchAll();
      };
    }
  }

  function boot(evt) {
    var scope = evt && evt.target ? evt.target : document;
    scope.querySelectorAll('[data-workshop-events-calendar]').forEach(function (root) {
      if (evt && evt.type === 'shopify:section:load') {
        root.__wecBound = false;
      }
      initSection(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
